import { baseUrl } from '@/api/types';

export function warehousePurchaseIndexUrl() {
  return `${baseUrl}/warehouse-purchases`;
}

export function warehousePurchaseDeleteUrl(purchaseId) {
  return `${warehousePurchaseIndexUrl()}/${purchaseId}`;
}

export function warehousePurchaseFilesUrl() {
  return `${warehousePurchaseIndexUrl()}/files`;
}

export function warehousePurchaseDetailsUrl(purchaseId) {
  return `${warehousePurchaseIndexUrl()}/${purchaseId}/details`;
}

export function warehousePurchaseCreateUrl() {
  return `${warehousePurchaseIndexUrl()}/create`;
}

export function warehousePurchaseEditUrl(purchaseId) {
  return `${warehousePurchaseIndexUrl()}/${purchaseId}/edit`;
}

export function warehousePurchaseStoreUrl() {
  return `${warehousePurchaseIndexUrl()}`;
}

export function warehousePurchaseUpdateUrl(purchaseId) {
  return `${warehousePurchaseIndexUrl()}/${purchaseId}`;
}

export function warehousePurchasePaymentIndexUrl(purchaseId) {
  return `${baseUrl}/warehouse-purchase-payments/${purchaseId}`;
}

export function warehousePurchasePaymentModalCreateUrl(purchaseId) {
  return `${baseUrl}/warehouse-purchase-payments/${purchaseId}/create`;
}

export function warehousePurchasePaymentModalEditUrl(paymentId) {
  return `${baseUrl}/warehouse-purchase-payments/${paymentId}/edit`;
}

export function warehousePurchasePaymentModalStoreUrl(purchaseId) {
  return `${baseUrl}/warehouse-purchase-payments/${purchaseId}`;
}

export function warehousePurchasePaymentModalUpdateUrl(paymentId) {
  return `${baseUrl}/warehouse-purchase-payments/${paymentId}/update`;
}

export function warehousePurchasePaymentDeleteUrl(purchaseId) {
  return `${baseUrl}/warehouse-purchase-payments/${purchaseId}`;
}

export function warehousePurchasePaymentCheckUrl(invoiceId) {
  return `${baseUrl}/warehouse-purchase-payment-check/${invoiceId}`;
}

export function warehousePurchasePaymentValidateUrl() {
  return `${baseUrl}/warehouse-purchase-payment-validation`;
}

export function warehousePurchaseRequisitesIndexUrl() {
  return `${baseUrl}/warehouse-purchase-requisites`;
}

export function warehousePurchaseRequisitesUpdateUrl(purchaseId) {
  return `${warehousePurchaseRequisitesIndexUrl()}/${purchaseId}`;
}

export function warehousePurchaseRestoreUrl(purchaseId) {
  return `${baseUrl}/warehouse-purchase-restore/${purchaseId}`;
}

